"use client"

import { sendBlockEvent } from "@/utils/gtm"
import { transformProperties } from "@/utils/simplifyData"
import { Typography } from "@mui/material"
import { colors, useIsDesktop, useIsTabletOnly } from "ui"
import BlockWrapper from "../common/BlockWrapper"
import SwiperCardBoxesContent from "../common/SwiperCardBoxesContent"

const CardsBoxesContentComponent = ({ id, data }: any) => {
  const { title, itemsList } = data
  const isDesktop = useIsDesktop()
  const isTablet = useIsTabletOnly()

  return (
    <BlockWrapper
      id={id}
      style={isDesktop ? { padding: "0" } : { padding: "56px 0" }}
    >
      <Typography variant="h2" color={colors.black}>
        {title.value}
      </Typography>
      <SwiperCardBoxesContent
        itemsList={itemsList}
        showArrowsNavigation={true}
        desktopSlidesPerView={
          isTablet
            ? 2 // Tablet: half of desktop slides
            : isDesktop
              ? 4 // Desktop
              : 1 // Mobile
        }
        onItemClick={(item) => {
          const { title: itemTitle } = transformProperties(item?.properties)
          sendBlockEvent({
            blockId: id || "",
            title: title.value,
            componentName: "מוצרים נוספים",
            productName: data?.formDefaultInsuranceType,
            buttonName: "אייקון +",
            actionName: itemTitle?.value || undefined,
            eventPrefix: "lead",
          })
        }}
      />
    </BlockWrapper>
  )
}

export default CardsBoxesContentComponent
